/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View, type TextStyle } from 'react-native';
import { PaperSheet } from '../ticket/PaperSheet';
import { modalExperience } from './modalExperience.styles';

type Props = {
  /** Si se omite, solo se muestra título/subtítulo. */
  kicker?: string;
  /** Si se omite, el título va en `ModalScreenHeader` arriba. */
  title?: string;
  titleStyle?: TextStyle;
  subtitle?: string | null;
  count?: number;
  countLabel?: string;
  /** Badge de texto (ej. "12 u.", "Stock") en lugar del contador numérico. */
  badgeText?: string;
  /** Badge custom (ej. StatusPill). Tiene prioridad sobre count/badgeText. */
  badge?: React.ReactNode;
};

export function ModalHeroHeader({
  kicker,
  title,
  titleStyle,
  subtitle,
  count,
  countLabel = 'ítems',
  badgeText,
  badge,
}: Props) {
  const showNumericBadge = badge == null && count != null && badgeText == null;
  const showTextBadge = badge == null && badgeText != null;

  return (
    <PaperSheet padded>
      <View style={modalExperience.heroRow}>
        <View style={modalExperience.heroText}>
          {kicker ? <Text style={modalExperience.heroKicker}>{kicker}</Text> : null}
          {title ? <Text style={[modalExperience.heroTitle, titleStyle]}>{title}</Text> : null}
          {subtitle ? (
            <Text style={modalExperience.heroSubtitle} numberOfLines={3} ellipsizeMode="tail">
              {subtitle}
            </Text>
          ) : null}
        </View>
        {badge ?? null}
        {showNumericBadge ? (
          <View style={modalExperience.countBadge}>
            <Text style={modalExperience.countValue}>{count}</Text>
            <Text style={modalExperience.countLabel}>{countLabel}</Text>
          </View>
        ) : null}
        {showTextBadge ? (
          <View style={modalExperience.pillBadge}>
            <Text style={modalExperience.pillBadgeText}>{badgeText}</Text>
          </View>
        ) : null}
      </View>
    </PaperSheet>
  );
}
